setTimeout(function() {
  $('.flash-message').fadeOut('slow');
}, 4000);